<template>
  <div class="profile-picture text-center">
    <TopMenu
      :title="$t('PROFILE.PICTURE.PAGE_LABEL')"
      back-to="/dashboard/profile"
      dark-background
    />
    <div class="container-fluid content">
      <form class="form-profile-picture m-2">
        <div class="row-item-transparent-with-border mt-3 mb-4 text-left">
          <h3>{{ $t('PROFILE.PICTURE.MENU_TITLE') }}</h3>
        </div>
        <div>
          <croppa
            v-model="croppa"
            :initial-image="computeImage"
            :placeholder="$t('PHOTO.IMPORT')"
            :prevent-white-space="true"
            :show-remove-button="false"
            :disabled="!selectedProfilePictureIsDefault"
            :placeholder-font-size="22"
            :placeholder-color="'#0C2340'"
            :width="200"
            :height="200"
            initial-size="cover"
          />

        </div>
        <ActionButton
          v-if="!(selectedProfilePictureString && !selectedProfilePictureIsDefault)"
          class="btn btn-lg btn-primary btn-block mt-3 mb-3"
          @click="save"
        >{{ $t("PROFILE.PICTURE.SAVE_BUTTON") }}</ActionButton>
        <ActionButton
          v-if="selectedProfilePictureString && !selectedProfilePictureIsDefault"
          class="btn btn-lg btn-danger btn-block mt-3 mb-3"
          @click="deleteProfilePicture"
        >{{ $t("PROFILE.PICTURE.DELETE_BUTTON") }}</ActionButton>
        <ActionButton
          v-if="croppa && croppa.chosenFile"
          class="btn btn-lg btn-danger btn-block mt-3 mb-3"
          @click="croppa.remove()"
        >{{ $t("PROFILE.PICTURE.CANCEL_BUTTON") }}</ActionButton>
      </form>
    </div>
    <BottomMenu/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TopMenu from '@/components/Menu/TopMenu';
import BottomMenu from '@/components/Menu/BottomMenu';
import ActionButton from '@/components/Actions/ActionButton';
import UrlHelper from '@/helpers/url-helper';

export default {
  name: 'ProfilePicture',
  components: {
    ActionButton,
    TopMenu,
    BottomMenu,
  },
  mixins: [UrlHelper],
  data() {
    return {
      croppa: {},
    };
  },
  computed: {
    ...mapState('member', [
      'selectedProfilePictureString',
      'selectedProfilePictureIsDefault',
    ]),
    computeImage() {
      return !this.selectedProfilePictureIsDefault ? this.selectedProfilePictureString : null;
    },
  },

  watch: {
    selectedProfilePictureString: {
      handler(newVal) {
        if (!this.selectedProfilePictureIsDefault && typeof this.croppa.refresh === 'function' && newVal) {
          this.croppa.refresh();
        }
      },
      immediate: true,
    },
  },
  created() {
    this.$store.dispatch('member/currentProfilePicture');
  },
  methods: {
    save() {
      if (this.croppa.chosenFile) {
        this.croppa.generateBlob((blob) => {
          const file = new File(
            [blob],
            this.croppa.chosenFile.name,
            { type: this.croppa.chosenFile.type },
          );
          this.$store
            .dispatch('member/saveProfilePicture', {
              file,
            })
            .then(() => {
              this.$store.commit('alerts/setAlert', {
                msg: 'PROFILE.PICTURE.CONFIRMATION_MESSAGE',
              });
              this.$store.dispatch('member/currentProfilePicture');
            });
        });
      } else {
        let msg = 'PROFILE.PICTURE.NO_PICTURE_SELECTED';
        if (this.selectedProfilePicture) {
          msg = 'PROFILE.PICTURE.NO_NEW_PICTURE_SELECTED';
        }
        this.$store.commit('alerts/setAlert', { msg });
      }
    },
    deleteProfilePicture() {
      this.$store.dispatch('member/deleteProfilePicture').then(() => {
        this.$store.commit('member/selectedProfilePicture', null);
        this.$store.commit('alerts/setAlert', {
          msg: 'PROFILE.PICTURE.DELETED_CONFIRMATION_MESSAGE',
        });
        this.croppa.refresh();
      });
    },
  },
};
</script>

<style scoped lang="scss">
div {
  &.profile-picture {
    height: 100%;
  }
  &.content {
    padding-top: $top-menu-height;
    padding-bottom: $bottom-menu-height;
    background-color: $base;
    min-height: 100%;
  }
  &.croppa-container {
    border: 1px solid #000;
    border-radius: 10px;
    border-style: dashed;
    width: 200px;
    height: 200px;
    margin: auto;
    overflow: hidden;
  }
}
</style>
